import { __awaiter, __generator } from "tslib";
import { fetchOfficeComponentContext } from '@office-start/component-context-service';
import { queryCache } from '@office-start/data-fetching';
import { fetchIdentity, getOfficeIdentity, } from '@office-start/identity-service';
import { executeConsumerInstallInfoConfigDataFlow } from './executeConsumerInstallInfoConfigDataFlow';
export function fetchConsumerInstallInfoConfig() {
    return __awaiter(this, void 0, void 0, function () {
        var context, identityResult, identity, _a, queryKey;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, fetchOfficeComponentContext()];
                case 1:
                    context = _b.sent();
                    identityResult = getOfficeIdentity();
                    if (!identityResult) return [3 /*break*/, 2];
                    _a = identityResult;
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, fetchIdentity()];
                case 3:
                    _a = _b.sent();
                    _b.label = 4;
                case 4:
                    identity = _a;
                    queryKey = ['ConsumerInstallInfoConfig'];
                    return [2 /*return*/, queryCache.fetchQuery(queryKey, function () { return executeConsumerInstallInfoConfigDataFlow(context, identity); }, {
                            staleTime: Infinity,
                            cacheTime: Infinity,
                        })];
            }
        });
    });
}
//# sourceMappingURL=fetchConsumerInstallConfig.js.map